export const osa_id = 5
export const request_url = 'https://api.sum.ba/'
export const request_url_hrm = 'https://api.hrm.sum.ba/'